import { HttpClient } from '@angular/common/http'
import { Component, OnInit, inject } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { ActivatedRoute } from '@angular/router'

@Component({
    selector: 'app-punch-list-complete',
    templateUrl: './punch-list-complete.component.html',
    standalone: true,
    imports: [FormsModule],
})
export class PunchListCompleteComponent implements OnInit {
    private http = inject(HttpClient)
    private route = inject(ActivatedRoute)

    private token = ''
    status: 'loading' | 'success' | 'error' = 'loading'
    comment = ''
    commentStatus: 'idle' | 'submitting' | 'submitted' | 'error' = 'idle'

    ngOnInit() {
        this.token = this.route.snapshot.paramMap.get('token') ?? ''
        if (!this.token) {
            this.status = 'error'
            return
        }

        this.http.post(`api/PunchList/MarkDoneByToken?token=${encodeURIComponent(this.token)}`, null).subscribe({
            next: () => (this.status = 'success'),
            error: () => (this.status = 'error'),
        })
    }

    submitComment() {
        if (!this.comment.trim() || !this.token) return

        this.commentStatus = 'submitting'
        this.http
            .post(`api/PunchList/SubmitCompletionComment?token=${encodeURIComponent(this.token)}`, {
                comment: this.comment.trim(),
            })
            .subscribe({
                next: () => (this.commentStatus = 'submitted'),
                error: () => (this.commentStatus = 'error'),
            })
    }
}
